// extracted by mini-css-extract-plugin
module.exports = {"titleContent":"styles_titleContent__iNnaD","wrap":"styles_wrap__hxo7P","cnt":"styles_cnt__HaN5y","contnet":"styles_contnet__hJz2N","subTitle":"styles_subTitle__0Qmwp"};